/* eslint-disable arrow-body-style */
import React from 'react';
import { useLinkAnalysisResultsStore } from '../../mothership/linkAnalysisResults.state';
import { linkAnalysisId } from '../../types';

export const QeHighlightedPaths = () => {
  const paths = useLinkAnalysisResultsStore(
    (state) => state.qeHighlightedPaths
  );
  const id = `${linkAnalysisId}QeHighlightedPaths`;

  return (
    <div id={id} data-cy={id} style={{ display: 'none' }}>
      {paths}
    </div>
  );
};
